export enum WorkspaceVisibility {
  private = 'private',
  public = 'public',
  organization = 'organization',
  personal = 'personal',
}
